/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import { ID } from "src/libs/interfaces/layouts"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { getCssDemention, getID } from "src/libs/utilities"
import { IDelimiterEdge } from "./Edge1"

export default function Edge3 (props: IDelimiterEdge): JSX.Element {
	const [id, ] = useState<ID>( getID("edge") )
		useEffect(() => {
			addCSSClass(
				`edge-${id}`,
				`.edge-${id} {
					${
						!!props.item.position
							?
							`width: ${getCssDemention(props.item.position?.width, "calc(100% + 120px)")}!important; 
							height: ${getCssDemention(props.item.position?.height, "auto")}!important;
							z-index: ${props.item.position.z }!important;
							position: absolute;
							top:0;
							transform: translateX(${getCssDemention(props.item.position?.left, "-60px")})  translateY(${getCssDemention(props.item.position.top, "0")}) rotate(${ props.item.position.rotate|| 0 }deg) scale(${props.item.position.scale || 1})!important;
							`
							:
							``
					}
					.picto {
						height: ${getCssDemention(props.item.position?.height, "auto")}!important;
					}
				}`
			)
			return () => {
				removeCSSClass(`edge-${id}`)
			}
		},[])
	return <div className={`w-100 flex-centered edge-${id} delimiter-edge-13`}>
		<svg 
			version="1.1" 
			xmlns="http://www.w3.org/2000/svg" 
			xmlnsXlink="http://www.w3.org/1999/xlink" 
			x="0px" 
			y="0px" 
			viewBox="0 0 500 48.9" 
			xmlSpace="preserve"
			className={`landing-delimiter-torn picto`}
		>    
			<path  fill={props.item.fill || "var(--force-contast-color)"} d="M447.8,30.7c-4-3.5-9-7.9-14.6-12.9c10,0,19.1,0,28,0C456.3,22.5,451.5,27.2,447.8,30.7z"/>
			<path  fill={props.item.fill || "var(--force-contast-color)"} d="M277.6,17.7c9,0,18,0,28.8,0c-3.1,3.5-5.3,6-7.5,8.3c-7.5,7.6-7.5,7.6-15.1,0c-2.3-2.3-4.5-4.7-6.8-7
				C277.2,18.6,277.4,18.2,277.6,17.7z"/>
			<path  fill={props.item.fill || "var(--force-contast-color)"} d="M355.7,17.9c9.1,0,18.1,0,27.2,0c0.3,0.4,0.6,0.8,0.9,1.1c-4.4,4.5-8.9,8.9-13.4,13.3c-0.4,0.4-1.8,0.3-2.2-0.1
				c-4.5-4.3-8.8-8.7-13.2-13.1C355.2,18.7,355.5,18.3,355.7,17.9z"/>
			<path  fill={props.item.fill || "var(--force-contast-color)"} d="M212.6,30.6c-3.5-3.5-8.2-8.1-12.9-12.8c8.7,0,17.8,0,27,0C221.6,22.5,216.7,26.9,212.6,30.6z"/>
			<path  fill={props.item.fill || "var(--force-contast-color)"} d="M121,17.9c9.4,0,18.5,0,28.2,0c-5.4,4.9-10.3,9.3-14.8,13.3C130.9,27.7,126.2,23,121,17.9z"/>
			<path fill="#e20808" d="M109.8,32.5c-9.5,0-18.5,0-29.3,0c3.4-3.6,5.8-6.3,8.4-8.9c6.8-6.9,6.9-6.9,13.7,0c2.2,2.2,4.4,4.5,6.6,6.8
				C109.5,30.7,109.5,31.3,109.8,32.5z"/>
			<path fill="#990000" d="M187.3,32.5c-9,0-18,0-27,0c-0.3-0.4-0.6-0.8-0.9-1.2c4.5-4.4,9-8.9,13.5-13.2c0.4-0.4,1.8-0.2,2.2,0.2
				c4.5,4.3,8.8,8.7,13.2,13C188,31.6,187.7,32.1,187.3,32.5z"/>
			<path fill="#999900"  d="M265.6,32.4c-9.1,0-18.1,0-27.2,0c-0.3-0.4-0.5-0.8-0.8-1.2c4.4-4.3,8.8-8.7,13.2-13c0.4-0.4,1.8-0.6,2.2-0.2
				c4.6,4.3,9,8.8,13.5,13.2C266.3,31.6,265.9,32,265.6,32.4z"/>
			<path fill="#0033CC" d="M329.5,17.5c5.1,5.2,9.7,9.8,14.6,14.8c-9.1,0-18.2,0-29.2,0C320.4,26.7,325,22.1,329.5,17.5z"/>
			<path fill="#CC6600" d="M393.9,32.3c5.6-5.4,10.2-9.9,14.3-13.9c4.4,4.4,9.1,9.1,14,13.9C413.1,32.3,404,32.3,393.9,32.3z"/>
			<path  fill={props.item.fill || "var(--force-contast-color)"} d="M42.9,17.8c9.4,0,18.5,0,28,0c-5.2,4.9-10,9.3-14.5,13.5C52.8,27.7,48.1,23,42.9,17.8z"/>
			<path  fill={props.item.fill || "var(--force-contast-color)"} d="M243.4,14.8c-1.5,4.7-18.6,21-21.2,20.9C229.1,28.9,236.3,21.7,243.4,14.8z"/>
			<path  fill={props.item.fill || "var(--force-contast-color)"} d="M299.5,35.9c7.6-7.3,14.9-14.3,21.7-20.9C321.3,17.7,304.3,35.2,299.5,35.9z"/>
			<path  fill={props.item.fill || "var(--force-contast-color)"} d="M26,14.9c7.3,7,14.5,14.1,21.8,21.1C39.6,29.9,32.5,22.7,26,14.9z"/>
			<path  fill={props.item.fill || "var(--force-contast-color)"} d="M104.1,15c3.9,0,20.7,16.5,21.6,21.4C117.8,30,110.9,22.6,104.1,15z"/>
			<path  fill={props.item.fill || "var(--force-contast-color)"} d="M141.7,35.8c8.1-8.1,15.3-15.3,22.5-22.4c0.3,0.4,0.7,0.7,1,1.1C164.1,18.8,146.9,35.6,141.7,35.8z"/>
			<path  fill={props.item.fill || "var(--force-contast-color)"} d="M183.6,13.4c7.2,7.1,14.4,14.3,22.2,22c-4.2,0.3-20.1-14.5-23.4-20.6C182.8,14.3,183.2,13.9,183.6,13.4z"/>
			<path  fill={props.item.fill || "var(--force-contast-color)"} d="M360.6,36.2c-7.3-7.3-14.4-14.5-21.4-21.5C342.3,14.7,359.7,31.7,360.6,36.2z"/>
			<path  fill={props.item.fill || "var(--force-contast-color)"} d="M378.3,36.1c7.4-7.1,14.6-14.1,21.9-21C399.5,17.4,383.5,34.2,378.3,36.1z"/>
			<path  fill={props.item.fill || "var(--force-contast-color)"} d="M87,14.1c-7.4,7.3-14.5,14.4-21.3,21.2C65.9,32.8,82.1,16,87,14.1z"/>
			<path  fill={props.item.fill || "var(--force-contast-color)"} d="M282.9,36.9c-7.7-8-14.7-15.3-21.2-22.1C263.6,14.4,280.9,30.8,282.9,36.9z"/>
			<path  fill={props.item.fill || "var(--force-contast-color)"} d="M437.7,36.9c-7.1-7.2-14.2-14.3-21.3-21.5c0.1,0,0.1-0.1,0.2-0.1c7.3,7,14.5,14,21.8,21C438.1,36.5,437.9,36.7,437.7,36.9z"
				/>
			<path  fill={props.item.fill || "var(--force-contast-color)"} d="M457.7,35.7c6.4-6.4,13.4-13.5,20.5-20.6C477.6,17.3,461.9,34.1,457.7,35.7z"/>
					</svg>
	</div>
}

